import { render, staticRenderFns } from "./profileCard.vue?vue&type=template&id=05739ca4&scoped=true&"
import script from "./profileCard.vue?vue&type=script&lang=js&"
export * from "./profileCard.vue?vue&type=script&lang=js&"
import style0 from "./profileCard.vue?vue&type=style&index=0&id=05739ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05739ca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
